import { gameRules } from './gameRules';

const DICE_COUNT = gameRules.dice.count;

/**
 * Roll dice, preserving values where keptMask is true.
 */
export function rollDice(previous: number[] = [], keptMask: boolean[] = []): number[] {
  // Deterministyczne testy E2E: jeśli istnieje globalna kolejka mocków, pobieramy następną pozycję
  if (typeof window !== 'undefined') {
    const mockQueue = window.__MOCK_DICE_QUEUE__;
    if (Array.isArray(mockQueue) && mockQueue.length > 0) {
      const next = mockQueue.shift();
      if (Array.isArray(next) && next.length === DICE_COUNT) {
        // Zastosuj keptMask: zatrzymane indeksy nadal biorą poprzednią wartość aby nie nadpisać scenariusza segmentowego
        return next.map((v: number, i: number) => keptMask[i] ? previous[i] : v);
      }
    }
  }
  const dice: number[] = new Array(DICE_COUNT);
  for (let i = 0; i < DICE_COUNT; i++) {
    if (keptMask[i]) {
      dice[i] = previous[i];
    } else {
      dice[i] = 1 + Math.floor(Math.random() * gameRules.dice.faces);
    }
  }
  return dice;
}

/**
 * Returns true when all dice are kept.
 */
export function allKept(mask: boolean[]): boolean {
  return mask.length === DICE_COUNT && mask.every(Boolean);
}

/**
 * Toggle a keep flag at the given index.
 */
export function toggleKept(mask: boolean[], index: number): boolean[] {
  const next = [...mask];
  next[index] = !next[index];
  return next;
}

/**
 * Checks if the "Rescue by 5" rule applies to the given dice.
 * Rule: If no dice are scoring AND the sum is divisible by 5, player gets another roll.
 */
export function canRescueByFive(dice: number[], scoringDiceCount: number): boolean {
  if (scoringDiceCount > 0) return false; // Has scoring dice, no rescue needed
  const sum = dice.reduce((acc, val) => acc + val, 0);
  return sum % 5 === 0;
}
